var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home"},[_c('h1',{staticClass:"home-title"},[_vm._v("Flip The Word")]),_c('FlipCard',{attrs:{"list":_vm.wordsList,"index":_vm.currentIndex}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }